export default __webpack_public_path__ + "static/media/Foto22.12d6bba1.png";